import {LoaderFunction, LoaderFunctionArgs} from 'react-router-dom';

import {LoaderContext, LoaderWithContext} from './types';
import {getLoaderContext} from './context';

export function withContext<T extends LoaderWithContext>(
  loader: T,
): LoaderFunction {
  const boundLoader: LoaderFunction = (args) => {
    return runLoader(loader, args);
  };

  return boundLoader;
}

async function runLoader(loader: LoaderWithContext, args: LoaderFunctionArgs) {
  const {graphQL, locale, shop} = getLoaderContext('app');

  const context = {
    query: graphQL.query,
    locale,
    shop,
  } as LoaderContext;

  return loader(args, context);
}
